/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useNetworkStatus from "../../../_hooks/useNetworkStatus";
import {
  accept_assessment_kit_action,
  get_assigned_assessment_kit_details_data_action,
} from "../../../redux/_actions";
import { useDispatch, useSelector } from "react-redux";
import { appRoutes } from "../../../_routes/app-routes";
import { ASSESSMENT_ASSIGN_STATUS } from "../../../_constants/AssessmentConst";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

const constraints = {
  audio: {
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false,
  },
  video: true,
  echoCancellation: true,
};
function useTakeAssessmentInstructions(props) {
  const [assessmentStart, setAssessmentStart] = useState(false);
  const [permissionAllowed, setPermissionAllowed] = useState(false);
  const [internetStatus, setInternetStatus] = useState(false);
  const [cameraAccess, setCamerAceess] = useState(false);
  const [assessementDetails, setAssessmentDetails] = useState(null);

  const vidRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const { candidateAssignedAssessmentData } = useSelector(
    (state) => state.get_assigned_assessment_kit_details_data_reducer
  );

  const networkStatus = useNetworkStatus();

  useEffect(() => {
    if (navigator.mediaDevices.getUserMedia !== null) {
      setCamerAceess(true);
    }
  }, []);
  useEffect(() => {
    if (!permissionAllowed && cameraAccess)
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          setPermissionAllowed(true);
        })
        .catch((e) => {
          setPermissionAllowed(false);
        });
  }, [cameraAccess, permissionAllowed]);

  useEffect(() => {
    if (candidateAssignedAssessmentData) {
      setAssessmentDetails(candidateAssignedAssessmentData);
    }
  }, [candidateAssignedAssessmentData]);

  useLayoutEffect(() => {
    callCameraOn();
    return function cleanup() {
      stopCamera();
    };
  }, [cameraAccess, permissionAllowed]);

  useEffect(() => {
    setInternetStatus(networkStatus);
  }, [networkStatus]);

  useEffect(() => {
    setAssessmentStart(cameraAccess && permissionAllowed && networkStatus);
  }, [cameraAccess, permissionAllowed, networkStatus]);

  useEffect(() => {
    window.scroll(0, 0);
    const callApi = async (id) => {
      await dispatch(get_assigned_assessment_kit_details_data_action(id));
    };
    let id = params?.assignedAssessmentId;
    if (id) callApi(id);
  }, [params]);

  const callCameraOn = () => {
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        vidRef.current.srcObject = stream;
      })
      .catch((e) => setPermissionAllowed(false));
  };
  const stopCamera = () =>
    vidRef.current &&
    vidRef.current.srcObject &&
    vidRef.current.srcObject.getTracks().forEach((t) => t.stop());

  const onStartClick = async () => {
    if (assessementDetails?.status === ASSESSMENT_ASSIGN_STATUS.accepted) {
      navigate(
        appRoutes.assessementKit.takeAssessment.replace(
          ":assignedAssessmentId",
          assessementDetails?.id
        )
      );
    } else if (
      assessementDetails?.status === ASSESSMENT_ASSIGN_STATUS.assigned
    ) {
      await dispatch(accept_assessment_kit_action(assessementDetails?.id));
      await dispatch(
        get_assigned_assessment_kit_details_data_action(assessementDetails?.id)
      );
    } else showWarningMessage("Unable to proceed with the Assessment Kit.");
  };

  const onBacktoAssessementsClick = () => {
    navigate(appRoutes.assessementKit.candidateAssignedAssessments);
  };

  return {
    cameraAccess,
    assessmentStart,
    internetStatus,
    permissionAllowed,
    vidRef,
    assessementDetails,
    onBacktoAssessementsClick,
    onStartClick,
  };
}

export default useTakeAssessmentInstructions;
